import axios from 'axios';

export default axios.create({
  // baseURL: "https://api.airyis.com/v1",
  baseURL: 'https://arcacademy.api.aanak.in/'
});
